import { IContainer, injectContainer } from './container';

export interface IEnv {
    getValue: <T>(envName: string) => T | null;
    getValueWithDefault: <T>(envName: string, defaultValue: T) => T;
    getNumber: (name: string, defaultValue?: number) => number;
    getBoolean: (name: string, defaultValue?: boolean) => boolean;
    getString: (name: string, defaultValue?: string) => string;
}

const TYPES = {
    IEnv: Symbol.for('IEnv'),
};

export function injectENV(container: IContainer = injectContainer()): IEnv {
    return container.get<IEnv>(TYPES.IEnv);
}

export function bindENV(val: IEnv, container: IContainer = injectContainer()) {
    return container.bind<IEnv>(TYPES.IEnv, val);
}
